const getAttendanceHostStatusResponse = (response) => {
  return response?.data?.status?.map((status) => ({
    label: status?.value,
    value: status?.key,
  }));
};

export default getAttendanceHostStatusResponse;
